// start:ng42.barrel
import './balance-admin-reports.component';
// end:ng42.barrel

